import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, InputGroup, } from 'react-bootstrap';
import { DateTimePicker, DatePicker, } from '@payit/cool-web-ui-library';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import SearchBar from '../../searchbar/SearchBar';
import AutopayService from '../../../service/AutopayService';
import AutopayDetailModal from './AutopayDetailModal';
import AsyncActionButton from '../../button/AsyncActionButton';
import './Autopay.css';
import Confirm from '../../confirm/Confirm';

class AutopayView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      selectedAccount: null,
      enrollmentUpdateMessage: null,
      searchType: null,
      unenrollConfirmationOpen: false,
      isLoading: false,
    };
    this.searchBar = React.createRef();
    this.enrollmentComboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'accountId',
        display: 'Account ID',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering ID',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  statefulInitialization() {
    const { click, } = this;
    if (click) {
      click();
    }
  }

  getAutopayAccounts = (searchFields, onCompletion = () => {}) => {
    AutopayService.searchAutopayEnrollments(searchFields)
      .then(response => response.data)
      .then(response => {
        this.setState({
          accounts: response.accounts,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  };

  getOverallPaymentActivity = (serviceOfferingId, startTime, endTime, onCompletion = () => {}) => {
    AutopayService.getAutopayActivity(serviceOfferingId, startTime, endTime)
      .then(response => {
        return response.data;
      })
      .then(response => {
        this.setState({
          accounts: response.accounts,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  };

  getAutopayBills = (serviceOfferingId, dueDate, onCompletion = () => {}) => {
    AutopayService.getAutopayBills(serviceOfferingId, dueDate)
      .then(response => response.data)
      .then(response => {
        this.setState({
          accounts: response.accounts,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  };

  unenroll = () => {
    const { selectedAccount, } = this.state;
    this.setState({
      enrollmentUpdateMessage: `Unenrolling Autopay account: ${selectedAccount.autopayEnrollmentId}`,
    });
    let nextMessage = '';
    AutopayService.updateAutopayEnrollment({
      autopayEnrollmentId: selectedAccount.autopayEnrollmentId,
      autopayEnrollmentStatus: 'UNENROLLED',
    }).then(() => {
      nextMessage = `Account ${selectedAccount.autopayEnrollmentId} unenrolled.`;
    }).catch((err) => {
      nextMessage = `Failed to unenroll account ${selectedAccount.autopayEnrollmentId}.`;

      console.error(err);
    }).finally(() => {
      this.setState({
        enrollmentUpdateMessage: nextMessage,
        unenrollConfirmationOpen: false,
        isLoading: false,
      });
    });
  };

  reset = () => {
    this.setState({
      accounts: [],
      selectedAccount: null,
      enrollmentUpdateMessage: null,
    });
  };

  onRowSelect = (row) => {
    this.setState({ selectedAccount: row, });
  };

  onEnrollmentSearch = (event) => {
    this.reset();
    this.setState({ searchType: 'enrollment', });
    const { search, combo, } = event;
    const { requestedState = {}, } = this.props;
    const { id = '', } = requestedState;

    const searchField = {};
    if (id && !search.value) {
      searchField.customerId = id;
    } else {
      searchField[combo.value] = search.value;
    }

    this.getAutopayAccounts(searchField, event.kill);
  };

  onOverallPaymentActivitySearch = () => {
    this.reset();
    this.setState({ isOverallPaymentActivityLoading: true, searchType: 'overallPaymentActivity', });

    this.getOverallPaymentActivity(
      this.state.overallPaymentActivitySoid,
      this.state.overallPaymentActivityStartDate,
      this.state.overallPaymentActivityEndDate,
      () => this.onLoadCompletion()
    );
  };

  onLoadCompletion() {
    this.setState({
      isOverallPaymentActivityLoading: false,
      isPaymentActivityByDueDateLoading: false,
    });
  }

  onPaymentActivityByDueDateSearch = () => {
    this.reset();
    this.setState({ isPaymentActivityByDueDateLoading: true, searchType: 'paymentActivityByDueDate', });
    this.getAutopayBills(
      this.state.paymentActivityByDueDateSoid,
      this.state.paymentActivityByDueDateDueDate,
      () => this.onLoadCompletion()
    );
  };

  onOverallPaymentActivitySoidChange = (event) => {
    this.setState({ overallPaymentActivitySoid: event.target.value, });
  };

  onOverallPaymentActivityStartDateChange = (dateTime) => {
    this.setState({ overallPaymentActivityStartDate: dateTime, });
  };

  onOverallPaymentActivityEndDateChange = (dateTime) => {
    this.setState({ overallPaymentActivityEndDate: dateTime, });
  };

  onPaymentActivityByDueDateSoidChange = (event) => {
    this.setState({ paymentActivityByDueDateSoid: event.target.value, });
  };

  onPaymentActivityByDueDateDueDateChange = (dateTime) => {
    this.setState({ paymentActivityByDueDateDueDate: dateTime, });
  };

  handleUnenrollConfirmationOpen = () => {
    this.setState({ unenrollConfirmationOpen: true, });
  };

  handleUnenrollConfirmationClose = () => {
    this.setState({ unenrollConfirmationOpen: false, });
  };

  renderUnerollButton = () => {
    const {
      selectedAccount,
      enrollmentUpdateMessage,
      unenrollConfirmationOpen,
      isLoading,
    } = this.state;

    if (selectedAccount.enrollmentStatus === 'UNENROLLED') {
      return null;
    }

    return (
      <>
        <Button variant='primary' onClick={this.handleUnenrollConfirmationOpen} style={{ marginLeft: '10px', }}>
          Unenroll
        </Button>
        <Confirm
          isLoading={isLoading}
          title="Unenroll AutoPay Enrollment"
          content={`Are you sure you want to unenroll autopay enrollment with id: ${selectedAccount.autopayEnrollmentId}?`}
          open={unenrollConfirmationOpen}
          onClose={this.handleUnenrollConfirmationClose}
          onYes={this.unenroll}
          onNo={this.handleUnenrollConfirmationClose}
        />
        {enrollmentUpdateMessage && <p style={{ marginTop: '10px', }}>{enrollmentUpdateMessage}</p>}
      </>
    );
  };

  renderAutopayAccountDetails = () => {
    const { accounts, selectedAccount, } = this.state;

    if (!selectedAccount) {
      return null;
    }

    const rawAccountDetails = accounts.find(account => account.autopayEnrollmentId === selectedAccount.autopayEnrollmentId);

    return (
      <div style={{ marginTop: '20px', }}>
        <p>{`Selected Plan: ${selectedAccount.autopayEnrollmentId}`}</p>
        <hr />
        <AutopayDetailModal selectedAccount={rawAccountDetails} />
        {this.renderUnerollButton()}
      </div>
    );
  };

  renderResults = () => {
    const { accounts, } = this.state;

    if (!accounts) {
      return null;
    }

    const grid = () => {
      if (this.state.searchType === 'overallPaymentActivity') {
        return (
          <Grid
            headers={[
              {
                value: 'occurredAt',
                display: 'Date',
              },
              {
                value: 'billId',
                display: 'Bill ID',
              },
              {
                value: 'billStatusChangedTo',
                display: 'Status Changed To',
              },
            ]}
            rows={accounts.map(account => ({
              value: [
                account.occurredAt,
                account.bill
                  ? account.bill.id
                  : 'Bill Not Found',
                account.billStatusChangedTo
                  ? account.billStatusChangedTo
                  : 'Status Not Found',
              ],
            }))}
            onRowSelect={this.onRowSelect}
          />
        );
      } if (this.state.searchType === 'paymentActivityByDueDate') {
        return (
          <Grid
            headers={[
              {
                value: 'autopayEnrollmentId',
                display: 'Enrollment ID',
              },
              {
                value: 'externalAccountId',
                display: 'External Account ID',
              },
              {
                value: 'serviceOfferingId',
                display: 'Customer Email Address',
              },
              {
                value: 'enrollmentStatus',
                display: 'Enrollment Status',
              },
              {
                value: 'isPaid',
                display: 'Paid',
              },
              {
                value: 'lastBillStatus',
                display: 'Last Bill Status',
              },
            ]}
            rows={accounts.map(account => {
              const latestBill = account.enrollment.autopayBills.sort((a, b) => new Date(b.occurredAt) - new Date(a.occurredAt))[0];
              const latestActivityOfLatestBill = latestBill.activity.sort((a, b) => new Date(b.occurredAt) - new Date(a.occurredAt))[0];
              return ({
                value: [
                  account.enrollment.id,
                  account.enrollment.externalAccountId,
                  account.enrollment.customer.emailAddress,
                  latestBill
                    ? latestBill.status
                    : 'No Bill Found',
                  latestBill
                    ? latestBill.paid
                    : 'No Bill Found',
                  latestActivityOfLatestBill
                    ? latestActivityOfLatestBill.billStatusChangedTo
                    : 'No Activity Found',
                ],
              });
            })}
            onRowSelect={this.onRowSelect}
          />
        );
      }
      return (
        <Grid
          headers={[
            {
              value: 'autopayEnrollmentId',
              display: 'Autopay Enrollment ID',
            },
            {
              value: 'externalAccountId',
              display: 'External Account ID',
            },
            {
              value: 'serviceOfferingId',
              display: 'Service Offering',
            },
            {
              value: 'enrollmentStatus',
              display: 'Status',
            },
          ]}
          rows={accounts.map(account => ({
            value: [
              account.autopayEnrollmentId,
              account.externalAccountId,
              account.serviceOfferingId,
              account.enrollmentStatus,
            ],
          }))}
          onRowSelect={this.onRowSelect}
        />
      );
    };

    return (
      <div style={{ marginTop: '20px', }}>
        <FieldSet title='Autopay Accounts' style={{ maxHeight: '500px', }}>
          {grid()}
        </FieldSet>
        {this.renderAutopayAccountDetails()}
      </div>
    );
  };

  _setClickEvent(click) {
    this.click = click;
  }

  formError() {
    if (new Date(this.state.overallPaymentActivityEndDate) - new Date(this.state.overallPaymentActivityStartDate) > 86400000) {
      return (<div className="error"><p>Date range must be 24 hours apart or less!</p></div>);
    }
    if (new Date(this.state.overallPaymentActivityEndDate) - new Date(this.state.overallPaymentActivityStartDate) < 0) {
      return (<div className="error"><p>End date must be after start date!</p></div>);
    }
    return (<div />);
  }

  render() {
    const { customerId = '', } = this.state;
    return (
      <div className='container'>
        <h5>Enrollment</h5>
        <SearchBar
          comboFields={this.enrollmentComboFields}
          defaultText={customerId}
          onClick={this.onEnrollmentSearch}
          clickConsumer={click => this._setClickEvent(click)}
        />
        <hr />

        <h5>Overall Payment Activity</h5>
        <row>ServiceOfferingId</row>
        <row>
          <row>
            <Form.Control
              type="text"
              placeholder="Enter a service offering ID."
              onChange={this.onOverallPaymentActivitySoidChange}
            />
          </row>
          <row>
            <div className="DatePicker">
              Start Date
              <DateTimePicker
                {...this.props}
                value={this.state.overallPaymentActivityStartDate}
                onChange={this.onOverallPaymentActivityStartDateChange}
                timeHint="Central time"
              />
            </div>
          </row>
          <div className="DatePicker">
            End Date
            <DateTimePicker
              {...this.props}
              value={this.state.overallPaymentActivityEndDate}
              onChange={this.onOverallPaymentActivityEndDateChange}
              timeHint="Central time"
            />
          </div>
          { this.formError() }
          <AsyncActionButton
            onClick={this.onOverallPaymentActivitySearch}
            contents="Search"
            variant="success"
            loadingVariant="secondary"
            isLoading={this.state.isOverallPaymentActivityLoading}
          />
          {

            this.state.formErrorOverallPaymentActivity

          }
        </row>
        <hr />
        <h5>Payment Activity By Due Date</h5>
        <row>Service Offering ID</row>
        <row>
          <InputGroup className="mt-2">
            <Form.Control
              type="text"
              placeholder="Enter a service offering ID."
              onChange={this.onPaymentActivityByDueDateSoidChange}
            />
          </InputGroup>
        </row>
        <row>Due Date</row>
        <row>
          <DatePicker
            value={this.state.paymentActivityByDueDateDueDate}
            onChange={this.onPaymentActivityByDueDateDueDateChange}
            hint="Select a due date"
          />
          <AsyncActionButton
            onClick={this.onPaymentActivityByDueDateSearch}
            contents="Search"
            variant="success"
            loadingVariant="secondary"
            isLoading={this.state.isPaymentActivityByDueDateLoading}
          />
          {this.state.formErrorPaymentActivityByDueDate}
        </row>
        <hr />

        {this.renderResults()}
      </div>
    );
  }
}

AutopayView.defaultProps = {
  requestedState: undefined,
};

AutopayView.propTypes = {
  requestedState: PropTypes.string,
};

export default AutopayView;
